<div class="dialog" role="document" aria-labelledby="manual-booking-title">
  <app-loader [isLoading]="isLoading"></app-loader>

  <div class="dialog-header">
    <span class="dialog-title" id="manual-booking-title">New Manual Utsav Booking</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  <div class="dialog-form">
    <!-- utsav + stay -->
    <div class="field-row">
      <div class="field">
        <label class="field-label" id="manual-utsav-label">Utsav <span aria-hidden="true">*</span></label>
        <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
          <mat-select aria-labelledby="manual-utsav-label" panelClass="ac-select-panel" [disableOptionCentering]="true" [(ngModel)]="utsavId" (selectionChange)="onUtsavChange()" placeholder="Select utsav">
            @for(u of utsavs; track u.utsavId){
            <mat-option [value]="u.utsavId">
              {{ u.name }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if(!isLoading && utsavs.length === 0){
        <span class="field-message">No utsav is open for booking.</span>
        }
        @if(selectedUtsav){
        <span class="field-message">Accommodation
          {{ selectedUtsav.accommodationStartDate }} to
          {{ selectedUtsav.accommodationEndDate }}</span>
        }
      </div>
      <div class="field">
        <span class="field-label">Stay <span aria-hidden="true">*</span></span>
        <div class="date-pair">
          <input type="date" class="text-box-active" aria-label="From date" [min]="minDate" [max]="maxDate" [(ngModel)]="fromDate" [disabled]="!selectedUtsav" />
          <input type="date" class="text-box-active" aria-label="To date" [min]="minDate" [max]="maxDate" [(ngModel)]="toDate" [disabled]="!selectedUtsav" />
        </div>
      </div>
    </div>

    <!-- who the booking is for -->
    <div class="field">
      <span class="field-label">Booking for</span>
      <div class="mode-row">
        <label class="mode-option">
          <input type="radio" name="manual-mode" [checked]="mode === 'ACCOUNT'" (change)="setMode('ACCOUNT')" />
          A devotee with an account
        </label>
        <label class="mode-option">
          <input type="radio" name="manual-mode" [checked]="mode === 'NO_ACCOUNT'" (change)="setMode('NO_ACCOUNT')" />
          A guest without an account
        </label>
      </div>
      @if(mode === 'NO_ACCOUNT'){
      <span class="field-message">
        The booking is made in the name of you or another devotee. That person only accompanies: they are not a guest and use no bed.
      </span>
      }
    </div>

    <!-- find the family / placeholder -->
    <div class="field">
      <span class="field-label">
        {{ mode === 'ACCOUNT' ? 'Find the devotee' : 'Book in the name of' }}</span>
      <div class="search-row">
        <select class="text-box-active search-by" aria-label="Search by" [(ngModel)]="searchBy">
          <option value="familyCode">Family code</option>
          <option value="aadhaarNumber">Aadhaar number</option>
        </select>
        <input type="text" class="text-box-active" inputmode="numeric" maxlength="12" autocomplete="off" [attr.aria-label]="searchBy === 'familyCode' ? 'Family code' : 'Aadhaar number'" [placeholder]="searchBy === 'familyCode' ? 'Family code' : 'Aadhaar number'" [(ngModel)]="searchText" (keydown.enter)="search()" />
        <button type="button" class="ac-secondary-small-btn" (click)="search()">Search</button>
        @if(mode === 'NO_ACCOUNT'){
        <button type="button" class="ac-secondary-small-btn" (click)="useMyName()">Use my name</button>
        }
      </div>
    </div>

    @if(family){
    <div class="field">
      <span class="field-label">Family
        {{ family.familyCode }}</span>
      <table class="table pick-table ac-responsive-table">
        <thead>
          <tr>
            <th scope="col">
              {{ mode === 'ACCOUNT' ? 'Primary' : 'Book as' }}
            </th>
            @if(mode === 'ACCOUNT'){ <th scope="col">Guest</th> }
            <th scope="col">Name</th>
            <th scope="col">Gender</th>
            <th scope="col">Date of birth</th>
            <th scope="col">Aadhaar</th>
          </tr>
        </thead>
        <tbody>
          @for(m of family.members; track m.devoteeId){
          <tr>
            <td data-label="Primary">
              <input type="radio" name="manual-primary" [attr.aria-label]="'Select ' + m.fullName" [checked]="primaryDevoteeId === m.devoteeId" [disabled]="!m.isAdult" (change)="selectPrimary(m)" />
            </td>
            @if(mode === 'ACCOUNT'){
            <td data-label="Guest">
              <input type="checkbox" [attr.aria-label]="'Add ' + m.fullName" [checked]="selectedMemberIds.has(m.devoteeId)" [disabled]="m.devoteeId === primaryDevoteeId" (change)="toggleMember(m)" />
            </td>
            }
            <td data-label="Name">
              {{ m.fullName }}
            </td>
            <td data-label="Gender">
              {{ m.gender }}
            </td>
            <td data-label="Date of birth">
              {{ m.dateOfBirth || '—' }}
            </td>
            <td data-label="Aadhaar">
              {{ m.aadhaarNumber || '—' }}
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>

    @if(mode === 'ACCOUNT' && family.visitors.length){
    <div class="field">
      <span class="field-label">Saved visitors</span>
      <table class="table pick-table ac-responsive-table">
        <thead>
          <tr>
            <th scope="col">Guest</th>
            <th scope="col">Name</th>
            <th scope="col">Relationship</th>
            <th scope="col">Gender</th>
            <th scope="col">Aadhaar</th>
          </tr>
        </thead>
        <tbody>
          @for(v of family.visitors; track v.visitorId){
          <tr>
            <td data-label="Guest">
              <input type="checkbox" [attr.aria-label]="'Add ' + v.fullName" [checked]="selectedVisitorIds.has(v.visitorId)" (change)="toggleVisitor(v)" />
            </td>
            <td data-label="Name">
              {{ v.fullName }}
            </td>
            <td data-label="Relationship">
              {{ v.relationship || '—' }}
            </td>
            <td data-label="Gender">
              {{ v.gender }}
            </td>
            <td data-label="Aadhaar">
              {{ v.aadhaarNumber || '—' }}
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    }
    }

    <!-- new guests -->
    <div class="field">
      <span class="field-label">
        {{ mode === 'ACCOUNT' ? 'New visitors' : 'Guests' }}</span>

      @if(newGuests.length){
      <ul class="guest-list">
        @for(g of newGuests; track $index){
        <li class="guest-item">
          <div class="guest-item-top">
            <span class="guest-item-name">
              {{ g.coVisitorFullName }}</span>
            <button type="button" class="guest-remove-btn" (click)="removeGuest($index)" [attr.aria-label]="'Remove ' + g.coVisitorFullName">Remove</button>
          </div>
          <dl class="guest-item-meta">
            <div>
              <dt>Gender</dt>
              <dd>
                {{ g.coVisitorGender }}
              </dd>
            </div>
            <div>
              <dt>Relationship</dt>
              <dd>
                {{ g.coVisitorRelationship || '—' }}
              </dd>
            </div>
            <div>
              <dt>Date of birth</dt>
              <dd>
                {{ g.coVisitorDateOfBirth }}
              </dd>
            </div>
            <div>
              <dt>Mobile</dt>
              <dd>
                {{ g.coVisitorMobile }}
              </dd>
            </div>
          </dl>
        </li>
        }
      </ul>
      }

      <div class="guest-form">
        <input type="text" class="text-box-active guest-name" maxlength="100" placeholder="Full name" aria-label="Guest full name" [(ngModel)]="newGuest.coVisitorFullName" />
        <input type="date" class="text-box-active guest-dob" aria-label="Guest date of birth" [max]="today" [(ngModel)]="newGuest.coVisitorDateOfBirth" />
        <select class="text-box-active guest-gender" aria-label="Guest gender" [(ngModel)]="newGuest.coVisitorGender" (ngModelChange)="onGuestGenderChange()">
          <option value="">Gender</option>
          @for(o of genderOptions; track o.value){ <option [value]="o.value">
            {{ o.label }}
          </option> }
        </select>
        <input type="text" class="text-box-active guest-aadhaar" inputmode="numeric" maxlength="12" placeholder="Aadhaar number" aria-label="Guest Aadhaar number" [(ngModel)]="newGuest.coVisitorIdentityRefNum" />
        <input type="tel" class="text-box-active guest-mobile" maxlength="10" placeholder="Mobile number" aria-label="Guest mobile number" [(ngModel)]="newGuest.coVisitorMobile" />
        <select class="text-box-active guest-relationship" aria-label="Guest relationship" [(ngModel)]="newGuest.coVisitorRelationship">
          <option value="">
            {{ mode === 'NO_ACCOUNT' && !hasSelfGuest ? 'Relationship (SELF for the guest)' : 'Relationship (optional)' }}
          </option>
          @for(r of relationOptions; track r){ <option [value]="r">
            {{ r }}
          </option> }
        </select>
        <button type="button" class="ac-secondary-small-btn guest-add-btn" (click)="addGuest()">Add guest</button>
      </div>
    </div>

    @if(mode === 'NO_ACCOUNT'){
    <div class="field-row">
      <div class="field">
        <label class="field-label" for="manual-guest-contact">Guest contact number <span aria-hidden="true">*</span></label>
        <input id="manual-guest-contact" type="tel" class="text-box-active" maxlength="10" autocomplete="off" [(ngModel)]="guestContact" />
      </div>
    </div>
    }

    <!-- summary -->
    <div class="summary">
      <span>Guests: <strong>
          {{ counts.total }}</strong></span>
      <span>Male
        {{ counts.male }} · Female
        {{ counts.female }} · Children
        {{ counts.children }}</span>
      @if(availabilityMessage){ <span class="field-message">
        {{ availabilityMessage }}</span> }
    </div>
  </div>

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" [disabled]="isLoading" (click)="checkAvailability()">Check availability</button>
    <button type="button" class="ac-primary-btn" [disabled]="isLoading" (click)="submit()">Create booking</button>
  </div>
</div>